import { Helmet } from "react-helmet-async";

export const MetaTags = (): JSX.Element | null => {
  return (
    <Helmet>
      <title>Kana | Investment Infrastructure for Nature and Climate</title>
      <meta name="title" content="Kana | Investment Infrastructure for Nature and Climate" />
      <meta
        name="description"
        content="Browse every British nature-based carbon project, all in one place. A showcase of the UK carbon market offering transparency, integrity and quality."
      />
    </Helmet>
  );
};
